import { render, staticRenderFns } from "./BigBanner.vue?vue&type=template&id=a94eac74&"
import script from "./BigBanner.vue?vue&type=script&lang=js&"
export * from "./BigBanner.vue?vue&type=script&lang=js&"
import style0 from "./BigBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports